import { useContext } from 'react';

import { AuthContext } from '../../providers/AuthProvider';
import { ApiMethod } from '../models/api-types.type';
import type { FeatureReviewResponse, UnitEconomicsResponse, VendorEconomicsDetail } from '../models/unit-economics.model';

/** pms-api-v2 src/unit-economics (super admin). */
export const UNIT_ECONOMICS_ROUTES = {
  overview: '/services/pms/admin/unit-economics',
  vendor: (vendorId: string) => `/services/pms/admin/unit-economics/vendors/${encodeURIComponent(vendorId)}`,
  featureReview: '/services/pms/admin/feature-review',
} as const;

export const useUnitEconomicsApi = () => {
  const { sendAuthGuardedRequest } = useContext(AuthContext);
  const send = (path: string) => sendAuthGuardedRequest(ApiMethod.GET, path) as Promise<any>;
  const query = (params: Record<string, string | undefined | false>) => {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) if (v) q.set(k, v);
    const s = q.toString();
    return s ? `?${s}` : '';
  };
  return {
    overview: (month: string, scope: 'real' | 'all', fresh = false): Promise<UnitEconomicsResponse> =>
      send(`${UNIT_ECONOMICS_ROUTES.overview}${query({ month, scope: scope === 'all' && 'all', fresh: fresh && '1' })}`),
    vendor: (vendorId: string, month: string): Promise<VendorEconomicsDetail> => send(`${UNIT_ECONOMICS_ROUTES.vendor(vendorId)}${query({ month })}`),
    featureReview: (fresh = false): Promise<FeatureReviewResponse> => send(`${UNIT_ECONOMICS_ROUTES.featureReview}${query({ fresh: fresh && '1' })}`),
  };
};
